import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { LuArrowUpDown } from "react-icons/lu";
import "../assets/css/styles.css";
import Popover from "./popover";
import axiosInstance from "../services/axiosInstance";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import { OrderStatusEnum } from "../enums/OrderEnum";
import ViewSheetPopup from "../Popup/viewSheetPopup";
import CheckinPopup from "../Popup/checkinPopup";
import JobSheet from "./jobSheet";
import { maxWidth } from "@mui/system";
import { PropagateLoader } from "react-spinners";

const SortIcon = ({ sortDirection }) => {
  if (sortDirection === "asc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  if (sortDirection === "desc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  return (
    <LuArrowUpDown
      className="ml-1 !w-4 !h-5"
      style={{ color: "#EFEFEF", opacity: "1" }}
    />
  );
};

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#376EA4",
      color: "#FAFDFF",
      fontSize: "16px",
      fontFamily: "InterBold",
      textAlign: "left",
      padding: "15px",
      opacity: "1",
      "@media screen and (min-width: 1250px) and (max-width: 1600px)": {
        fontSize: "14px",
      },
    },
    hoverStyle: {
      color: "#FAFDFF",
      opacity: "1",
    },
  },
  rows: {
    style: {
      cursor: "pointer",
      fontSize: "16px",
      color: "#828282",
      padding: "6px",
      backgroundColor: "rgba(252, 252, 252, 0.5)",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8)",
      borderTop: "1px solid rgba(239, 239, 239, 0.8)",
      //overflow: "hidden",
      "@media screen and (min-width: 1250px) and (max-width: 1600px)": {
        fontSize: "14px",
        padding: "4px 8px",
      },
    },
    highlightOnHoverStyle: {
      fontSize: "16px",
      color: "#202020",
      padding: "6px",
      backgroundColor: "#F4F9FF !important",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8)",
      borderTop: "1px solid rgba(239, 239, 239, 0.8)",
      "@media screen and (min-width: 1250px) and (max-width: 1600px)": {
        fontSize: "14px",
        padding: "4px",
      },
    },
  },
  table: {
    style: {
      display: "block",
      maxHeight: "calc(100vh - 330px)",
      height: "fit-content",
      overflowY: "auto",
      borderCollapse: "separate",
      borderSpacing: 0,
      "@media screen and (min-width: 1600px)": {
        maxHeight: "calc(100vh - 340px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 760px) and (max-width: 1250px)": {
        maxHeight: "calc(100vh - 330px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 768px) and (max-width: 1024px)": {
        maxHeight: "calc(100vh - 360px)",
        overflowX: "hidden",
      },
    },
  },
};

const formatDueDeliveryDate = (dueDeliveryDate) => {
  if (!dueDeliveryDate) return "";

  const date = new Date(dueDeliveryDate);

  // Extract day, month, hours, and minutes
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  // Format as dd.MM | HH:mm
  return `${day}.${month}.${year} | ${hours}:${minutes}`;
};

const CompletedOrderTable = ({ searchTerm }) => {
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [openCheckinPopup, setOpenCheckinPopup] = useState(false);
  const [jobSheetData, setJobSheetData] = useState({
    patientName: "",
    dentistName: "",
    standard_Notes: "",
    individual_Notes: "",
    workTypeDescription: "",
    workTypeName: "",
  });
  const [teethPositions, setTeethPositions] = useState([]);

  const HandleRemovePopUp = () => setOpenPopup(false);
  const HandleCloseCheckinPopup = () => setOpenCheckinPopup(false);

  const handleSendSelectedIds = async () => {
    const selectedIds = selectedRows.map((row) => row.id);
    try {
      const response = await axiosInstance.post("/api/order/postCheckBackIn", {
        ids: selectedIds,
      });
      if (response.isSuccess) {
        setOpenCheckinPopup(true);
        await fetchOrders();
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.error("Error sending selected IDs:", error);
    }
  };

  const option = {
    method: "open",
    resolution: Resolution.NORMAL,
    page: {
      margin: Margin.SMALL,
      format: "A4",
      orientation: "portrait",
    },
    canvas: { mimeType: "image/png", qualityRatio: 1 },
    overrides: { canvas: { useCORS: true } },
  };

  const getTargetElement1 = () => document.getElementById("job-sheet");

  const jobSheetHandleClick = () => {
    setOpenPopup(true);
    setIsVisible(true);
    handleGeneratePDF1();
  };

  const handleGeneratePDF1 = () => {
    setTimeout(() => {
      generatePDF(getTargetElement1, option);
      setIsVisible(false);
    }, 10);
  };

  const handlePreviewJobSheet = async (row) => {
    try {
      const rowId = row.id;
      const response = await axiosInstance.post(
        "/api/order/previewJobflowSheet",
        {
          OrderId: parseInt(rowId, 10),
        }
      );
      if (response) {
        setJobSheetData({
          patientName: response?.patientName,
          dentistName: response?.dentistName,
          standard_Notes: response?.standard_Notes || "",
          individual_Notes: response?.individual_Notes || "",
          workTypeDescription: response?.workTypeDescription || "",
          workTypeName: response?.workTypeName || "",
        });
        setTeethPositions(response?.teethPositions);
        jobSheetHandleClick();
      } else {
        alert("Failed to open pdf. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching workflow data:", error);
    }
  };

  const columns = [
    {
      name: "Praxis",
      selector: (row) => row.dentistName,
      sortable: true,
      sortFunction: (a, b) => a.dentistName.localeCompare(b.dentistName),
    },
    {
      name: "Patient",
      selector: (row) => row.patientName,
      sortable: true,
      sortFunction: (a, b) => a.patientName.localeCompare(b.patientName),
    },
    {
      name: "Arbeitsart",
      selector: (row) => row.workTypeName,
      sortable: true,
      sortFunction: (a, b) => a.workTypeName.localeCompare(b.workTypeName),
    },
    {
      name: "Ausgebucht",
      selector: (row) => new Date(row.timeStampRaw), // Use raw date for sorting
      sortable: true,
      format: (row) => row.timeStamp,
    },
    {
      id: "finalDeliveryDate",
      name: "Liefertermin",
      selector: (row) => new Date(row.finalDeliveryRaw), // Use raw date for sorting
      sortable: true,
      format: (row) => row.finalDelivery, // Display formatted date
    },
    {
      name: "Status",
      selector: (row) => row.orderStatusId,
      sortable: true,
      sortFunction: (a, b) => a.orderStatusId.localeCompare(b.orderStatusId),
      cell: (row) => (
        <span
          style={{
            padding: "3px 8px",
            color: "#00773B",
            backgroundColor: "#E8FAEE",
          }}
        >
          {row.orderStatusId}
        </span>
      ),
    },
    {
      name: "Vorschau",
      selector: (row) => row.create,
      sortable: false,
      maxWidth: "100px",
      cell: (row) => (
        <div className="gap-3 flex">
          {/* workflow */}
          <Popover
            trigger="hover"
            content={
              <p
                className="absolute -right-5 text-blue-400 px-2 py-0.5 3xl:py-1 leading-5 bg-blue rounded w-[125px] xl:w-[100px] 3xl:w-[125px] -top-7 text-lg xl:text-xs 3xl:text-lg whitespace-nowrap after:content-[' '] after:-bottom-2 after:right-8  after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-blue shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] max-w-fit"
                style={{}}
              >
                Auftragszettel
              </p>
            }
          >
            <button
              onClick={() => handlePreviewJobSheet(row)}
              className="rounded-lg p-1.5 3xl:p-2 my-1 border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)]"
              style={{
                backgroundColor: "rgba(201, 226, 252, 0.3)",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <img src="./icons/Jobsheet.svg" />
            </button>
          </Popover>
        </div>
      ),
      ignoreRowClick: true,
      allowoverflow: true,
      button: true,
    },
  ];

  const handleRowClick = (row) => {
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows.some((r) => r.id === row.id);
      if (isSelected) {
        // Remove row from selected rows
        return prevSelectedRows.filter((r) => r.id !== row.id);
      } else {
        // Add row to selected rows
        return [...prevSelectedRows, row];
      }
    });
  };

  const isRowSelected = (row) => {
    return selectedRows.some((r) => r.id === row.id);
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        "/api/order/getCheckedOutOrders"
      );
      if (response) {
        if (Array.isArray(response)) {
          const mappedOrders = response.map((order) => {
            // const deliveryDate = new Date(order.deliveryDate);
            // const lastUpdatedDate = new Date(order.checkoutDate);
            // const isDue = deliveryDate < lastUpdatedDate;
            return {
              id: order.orderId,
              dentistName: order.dentistName || "",
              patientName: order.patientName,
              workTypeName: order.workTypeName,
              orderStatusId:
                order.orderStatusId == OrderStatusEnum.Completed
                  ? "Completed"
                  : "NA",
              finalDelivery: formatDueDeliveryDate(order.deliveryDate),
              finalDeliveryRaw: order.deliveryDate, // Store raw date for sorting
              dueDelivery: formatDueDeliveryDate(order.dueDeliveryDate),
              timeStamp: formatDueDeliveryDate(order.checkoutDate),
              timeStampRaw: order.checkoutDate, // Store raw date for sorting
              isDue:
                new Date(order.deliveryDate) < new Date(order.checkoutDate),
              create: "",
            };
          });

          setOrders(mappedOrders);
          setSelectedRows([]);
        } else {
          setOrders([]);
          setSelectedRows([]);
        }
      } else {
        setOrders([]);
        setSelectedRows([]);
      }
    } catch (error) {
      setOrders([]);
      setSelectedRows([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredOrders = React.useMemo(() => {
    const clonedOrders = [...orders];
    return clonedOrders.filter(
      (order) =>
        order.dentistName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.patientName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.workTypeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.orderStatusId.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [orders, searchTerm]);

  return (
    <div>
      <style>
        {`
          #work-flow-sheet.hidden {
            display: none;
          }
        `}
      </style>
      <div>
        {loading ? (
          <div className="flex justify-center items-center min-h-60">
            <PropagateLoader color="rgb(55 110 164 / var(--tw-bg-opacity, 1))" />
          </div>
        ) : (
          <>
            <DataTable
              defaultSortFieldId="finalDeliveryDate"
              defaultSortAsc={true}
              noDataComponent={
                <div className="py-4 text-gray-500">
                  Es sind keine Datensätze zum Anzeigen vorhanden
                </div>
              }
              className=" mt-7 !rounded-xl shadow-[0_0_8px_rgba(44,99,152,0.2)] font-interRegular"
              scrollable
              scrollHeight="600px"
              columns={columns}
              data={filteredOrders}
              pagination={false}
              // selectableRows
              // onSelectedRowsChange={handleRowSelected}
              fixedHeader
              customStyles={customStyles}
              sortIcon={<SortIcon />}
              highlightOnHover={false}
              onRowClicked={handleRowClick}
              conditionalRowStyles={[
                {
                  when: (row) => row.isDue,
                  style: {
                    backgroundColor: "#FE725C33",
                    color: "#828282",
                  },
                },
                {
                  when: (row) => isRowSelected(row),
                  style: {
                    backgroundColor: "#cce5ff",
                    color: "#004085",
                  },
                },
              ]}
            />
            {!loading && (
              <div className="text-end mt-4">
                <button
                  className={`bg-blue text-2xl xl:!text-base 3xl:!text-2xl uppercase border ${
                    selectedRows.length > 0
                      ? "border-blue hover:bg-blue-800 hover:border-blue-800 text-white"
                      : "border-gray-300 bg-gray-300 text-gray-500 cursor-not-allowed"
                  } font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in`}
                  type="button"
                  onClick={handleSendSelectedIds}
                  disabled={selectedRows.length === 0}
                >
                  Wieder Einbuchen
                </button>
              </div>
            )}
          </>
        )}
      </div>

      {/* modal popup */}
      <ViewSheetPopup openPopUp={openPopup} closePopUp={HandleRemovePopUp} />
      <CheckinPopup
        openPopUp={openCheckinPopup}
        closePopUp={HandleCloseCheckinPopup}
      />

      {/* job sheet */}
      <JobSheet
        jobSheetData={jobSheetData}
        isVisible={isVisible}
        toothGridData={teethPositions}
      />
    </div>
  );
};

export default CompletedOrderTable;
